import { waterbureauRegistrationApi } from "@/lib/api"
import { useMutation } from "@tanstack/react-query"
import { queryClient } from "@/lib/queryClient"
import { WaterbureauRegistrationRequest } from "@/gen/api"

export const useRegisterWaterbureau = () => {
  return useMutation({
    mutationFn: async (request: WaterbureauRegistrationRequest) => {
      const response = await waterbureauRegistrationApi.registerWaterbureau(request)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["councils-list"] })
      queryClient.invalidateQueries({ queryKey: ["councils"] })
    },
  })
}
